module.exports = __webpack_public_path__ + "static/media/s3.25fb62c9.jpg";